import { useState, useCallback, useEffect, useContext, useMemo } from 'react';
import { debounce } from '@agilepoint/utils-common';
import { WindowSizeContext } from './context';
import { useGlobalEventManager } from '../global-events';
import { currentWindow } from '../env';

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState({windowWidth: currentWindow.innerWidth, windowHeight: currentWindow.innerHeight});
    const setWindowWidthDebounced = useMemo(() => debounce(setWindowSize, 200, currentWindow), []);
    const _onResize = useCallback(() => setWindowWidthDebounced({windowWidth: currentWindow.innerWidth, windowHeight: currentWindow.innerHeight}), [setWindowWidthDebounced]);
    const eventManager = useGlobalEventManager();
    useEffect(() => {
        eventManager.on('windowResize', _onResize);
        return () => {
            eventManager.off('windowResize', _onResize);
        };
    }, [_onResize, eventManager]);
    return windowSize;
}

export function useWindowSizeContext() {
    return useContext(WindowSizeContext);
}
